import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { QuotationListsClient } from '@/features/quotation-lists/QuotationListsClient';
import type { ListTab } from '@/features/quotation-lists/quotationLists.api';

interface ListsSearch {
  /** Which tab — in the URL, so a reload or a link lands on the same list. */
  list?: 'articles' | 'standardTexts' | 'addresses' | 'truckTypes';
}

export const Route = createFileRoute('/_shell/quotation-lists')({
  validateSearch: (search: Record<string, unknown>): ListsSearch => ({
    list:
      search['list'] === 'articles' ||
      search['list'] === 'standardTexts' ||
      search['list'] === 'addresses' ||
      search['list'] === 'truckTypes'
        ? search['list']
        : undefined,
  }),
  component: ListsRoute,
});

function ListsRoute() {
  const { list } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <QuotationListsClient
      list={list ?? 'craneTypes'}
      onList={(next: ListTab) =>
        void navigate({ search: { list: next === 'craneTypes' ? undefined : next }, replace: true })
      }
    />
  );
}
